/**
 * Тестовые функции для AMO полей
 * Предоставляет инструменты для тестирования функциональности полей
 */

import { debugMultiselectState, debugMultiselectHTML } from './amoFieldsDebugAnalysis.js';
import { setAmoFieldValue, clearMultiselectField } from './amoFieldsSetter.js';

/**
 * Тестовая функция для быстрого тестирования мультиселекта
 * @param {string|number} fieldId - ID поля
 * @param {Array<string>} values - Значения для установки (массив ID)
 */
export function testMultiselectSync(fieldId, values) {
    console.log(`🧪 Тестирование мультиселекта ${fieldId} со значениями:`, values);
    
    const runDebugSequence = (stage) => {
        console.log(`${stage}. Состояние:`);
        debugMultiselectState(fieldId);
        debugMultiselectHTML(fieldId);
    };
    
    runDebugSequence('1. Текущее');
    
    console.log('2. Установка новых значений...');
    const result = setAmoFieldValue(fieldId, values);
    
    setTimeout(() => {
        runDebugSequence('3. После изменения');
        console.log(`✅ Тест завершен для поля ${fieldId}, результат:`, result);
    }, 500);
    
    return result;
}

/**
 * Быстрый тест очистки мультиселекта
 * @param {string|number} fieldId - ID поля
 */
export function testClearMultiselect(fieldId) {
    console.log(`🧪 Тест очистки мультиселекта ${fieldId}`);
    
    const runDebugSequence = (stage) => {
        console.log(`${stage}. Состояние:`);
        debugMultiselectState(fieldId);
        debugMultiselectHTML(fieldId);
    };
    
    runDebugSequence('1. До очистки');
    
    console.log('2. Вызов setAmoFieldValue с пустым массивом:');
    const result1 = setAmoFieldValue(fieldId, []);
    
    console.log('3. Вызов clearMultiselectField:');
    const result2 = clearMultiselectField(fieldId);
    
    setTimeout(() => {
        runDebugSequence('4. После очистки');
        console.log('Результаты:', { setAmoFieldValue: result1, clearMultiselectField: result2 });
    }, 500);
    
    return { setAmoFieldValue: result1, clearMultiselectField: result2 };
} 